import db from '@/rxdb/database';
import { map } from 'rxjs';
import { getCachedObservable } from '@/rxdb/observablesCache';

export function getSupportsExport(projectId, supportsExportId) {
    return db
        .getProjectCollections(projectId)
        .supportsExports.findOne({ selector: { id: supportsExportId } })
        .$.pipe(map(mapSupportsExport));
}

export function getLastSupportsExport(projectId) {
    return db
        .getProjectCollections(projectId)
        .supportsExports.findOne({ selector: {}, sort: [{ createdAt: 'desc' }] })
        .$.pipe(map(mapSupportsExport));
}

export async function removeSupportsExport(projectId, supportsExportId) {
    const entity = await db
        .getProjectCollections(projectId)
        .supportsExports.findOne({ selector: { id: supportsExportId } })
        .exec();
    return entity.remove();
}

function mapSupportsExport(supportsExport) {
    if (supportsExport) {
        return {
            ...supportsExport.toMutableJSON(),
            filter: supportsExport.filter ? JSON.parse(JSON.stringify(supportsExport.filter)) : [],
        };
    } else {
        return null;
    }
}

export function getSupportsExports(projectId) {
    return getCachedObservable('getSupportsExports_' + projectId, () =>
        db
            .getProjectCollections(projectId)
            .supportsExports.find({ selector: {}, sort: [{ createdAt: 'asc' }] })
            .$.pipe(map((entities) => entities.map(mapSupportsExport))),
    );
}

export async function createSupportsExport(projectId, supportsExport) {
    const result = await db.getProjectCollections(projectId).supportsExports.insert({
        ...supportsExport,
        filter: supportsExport.filter ? JSON.parse(JSON.stringify(supportsExport.filter)) : [],
    });
    return result.toJSON();
}
